import { api } from "../../App/services/api";
function getFaqsInternal() {
    return api.get("/faq");
}
export default {
    getFaqsInternal: getFaqsInternal
};
